class SmartEventFormat {
	constructor(format){		
		this.Format = format;		
		this.ml 	= format.get_list("ml");
		this.info 	= null;
		this.rules 	= {};		
	}

	setInfo(value){
		this.info = value;
	}
	getInfo(){
		return this.info;
	}
	getRulesActives(){
		return this.rules.actives;	
	}
	getRulesActivesToString(){
		return JSON.stringify(this.rules.actives)	
	}
	getRulesActivesLists(){
		return this.rules.activesLists;	
	}
	getRulesActivesListsToString(){
		return JSON.stringify(this.rules.activesLists)	
	}
	format(){
		this.rules.actives = [];
		this.rules.lists   = [];
		this.rules.activesLists = [];
		if (this.info) {
			const {
				// Detail_action_alarm, 
				Detail_device_alarm,
				Detail_motion_alarm,
				Detail_rule_action_alarm,
				Detail_rule_face__alarm,
				Detail_rule_lpr__alarm,
				Detail_rule_obj_alarm,
			} = this.info;
			if (Detail_device_alarm && Detail_device_alarm.length > 0) {
				let tempDevice = `${this.ml.get("devices")} : `;
				Detail_device_alarm.forEach((it)=>{
					if (it) {						
						let dev 	= this.Format.render_device(it.deviceId);
						if (dev) {
							tempDevice += ` ${dev.name}, `;
						}
						if (it.detail_schedule_device && it.detail_schedule_device.length > 0) {
							const { start, end, interval } = it.detail_schedule_device[0];
							tempDevice += ` ${this.ml.get('schedule')} : ${start} - ${end} , ${this.ml.get("interval")} : ${interval} |`;	
						}

					}
				})
				this.rules.actives.push(tempDevice);
			}
			if (Detail_rule_obj_alarm && Detail_rule_obj_alarm.length > 0) {
				let tempObject = ` ${this.ml.get("object")} : `
				Detail_rule_obj_alarm.forEach((it)=>{
					if (it) {
						const {tag, prob} = it;
						tempObject += ` ${tag} , ${this.ml.get("probability")} : ${parseInt(parseFloat(prob) * 100 )}% |`; 
					}
				})
				this.rules.actives.push(tempObject);
			}
			if(Detail_motion_alarm && Detail_motion_alarm.length > 0){
				this.rules.actives.push(` ${this.ml.get("motion")} |`);
			}
			if(Detail_rule_action_alarm && Detail_rule_action_alarm.length > 0){
				let tempAction = ` ${this.ml.get("action")} : `
				Detail_rule_action_alarm.forEach((it)=>{
					if (it) {
						const {tag, prob} = it;
						tempAction += ` ${tag} , ${this.ml.get("probability")} : ${parseInt(parseFloat(prob) * 100 )}% |`; 					
					}

				})
				this.rules.actives.push(tempAction);
			}
			if(Detail_rule_face__alarm && Detail_rule_face__alarm.length > 0){
				let tempFace = ` ${this.ml.get("face")} : `;				
				Detail_rule_face__alarm.forEach((it)=>{
					if (it) {
						const { idList, entity } = it;
						if (idList) {
							const tempList = this.Format.render_lists(idList);
							if (tempList) {
								tempFace += ` ${this.ml.get("list")} : ${tempList.name}, `
							}
						}
						if (entity) {
							const tempEntity = this.Format.render_traineds(entity);
							if (tempEntity) {
								tempFace += ` ${this.ml.get("trained_user")} : ${tempEntity.userName}, `	
							}
						}
					}
				})
				this.rules.activesLists.push(tempFace);
			}
			if(Detail_rule_lpr__alarm && Detail_rule_lpr__alarm.length > 0){
				let tempLpr = ` ${this.ml.get("lpr")} : `;
				Detail_rule_lpr__alarm.forEach((it)=>{
					if (it) {
						const listTemp = this.Format.render_lists(it.idList);
						if (listTemp) {
							tempLpr += ` ${this.ml.get("list")} : ${listTemp.name} |`
						}
					}
				})
				this.rules.activesLists.push(tempLpr);
			}

		}
	}
}
export default SmartEventFormat;